<template>
   <template v-if="isLoading()">
      <Loading />
   </template>
   <template v-else>
      <div class="faq">
         <div class="header">
            <div class="container">
               <h3>سوالات متداول</h3>
            </div>
         </div>
         <div class="container">
            <div class="row pt-5 pb-5">
               <div class="accordion accordion-flush p-number">
                  <div class="accordion-item" v-for="item in faqs" :key="item.faqId">
                     <h2 class="accordion-header p-number" :id="`flush-headingOne_${item.faqId}`">
                        <button
                           class="accordion-button collapsed"
                           type="button"
                           data-bs-toggle="collapse"
                           :data-bs-target="`#flush-collapseOne_${item.faqId}`"
                           :aria-controls="`flush-collapseOne_${item.faqId}`"
                        >{{ item.question }}</button>
                     </h2>
                     <div
                        :id="`flush-collapseOne_${item.faqId}`"
                        class="accordion-collapse collapse"
                        :aria-labelledby="`flush-headingOne_${item.faqId}`"
                     >
                        <div class="accordion-body">{{ item.answer }}</div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </template>
</template>


<script>
import Loading from "../layout/aniresan/Loading.vue";

export default {
   components: {
      Loading,
   },
   data() {
      return {
         faqs: [],
         server: this.$store.state.server,
      };
   },
   beforeMount() {
      this.initHome();
   },
   methods: {
      isLoading() {
         return this.server.pendingRequests.length > 0;
      },
      initHome() {
         // if (db.select("homeData")) this.initData(db.select("homeData"));

         this.$server({
            method: "get",
            url: "/api/General/GetFaqs",
         })
            .then((response) => {
               this.initData(response.data);
            })
            .catch((error) => {
               console.log(error);
            });
      },
      initData(obj) {
         this.rootImagePath = obj.rootImagePath;
         this.faqs = obj.faqs;

         // db.insert("homeData", obj);
         this.loading = false;
      },
   },
};
</script>
<style>
.faq {
   width: 100%;
   height: auto;
   text-align: justify;
   padding-bottom: 100px;
}
.faq .header {
   width: 100%;
   height: 300px;
   background-image: url("../../assets/images/question1.jpg");
   background-size: cover;
   background-position: center;
   position: relative;
}
.faq .header::after {
   content: "";
   left: 0;
   bottom: 0;
   position: absolute;
   background-color: black;
   width: 100%;
   height: 300px;
   opacity: 0.3;
}
.faq .header h3 {
   text-align: right;
   padding-top: 100px;
   color: white;
   font-weight: bold;
   position: relative;
   z-index: 100;
}
@media screen and (max-width:768px) {
.faq .header,
.faq .header::after{
   height: 200px;
}
  
}
</style>